import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';

up.compiler('[data-bs-toggle="tooltip"]', (element: HTMLElement) => {
    const tooltip = new bootstrap.Tooltip(element);

    return () => tooltip.dispose();
});
